var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"groups"},[(_vm.webId != null)?_c('div',[_c('GroupsList')],1):_c('div',[_c('SolidLoginButton')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }